import ImagesHeaderBuyingSvg from '@/public/images/header/buying.svg';
import ImagesHeaderChevronLeftSvg from '@/public/images/header/chevron-left.svg';
import ImagesHeaderChevronRightSvg from '@/public/images/header/chevron-right.svg';
import ImagesHeaderCloseSvg from '@/public/images/header/close.svg';
import ImagesHeaderDashboardSvg from '@/public/images/header/dashboard.svg';
import ImagesHeaderLanguageSvg from '@/public/images/header/language.svg';
import ImagesHeaderLastViewedSvg from '@/public/images/header/last-viewed.svg';
import ImagesHeaderLogoutSvg from '@/public/images/header/logout.svg';
import ImagesHeaderMenuSvg from '@/public/images/header/menu.svg';
import ImagesHeaderNotificationsSvg from '@/public/images/header/notifications.svg';
import ImagesHeaderPortfolioSvg from '@/public/images/header/portfolio.svg';
import ImagesHeaderSearchSvg from '@/public/images/header/search.svg';
import ImagesHeaderSellingSvg from '@/public/images/header/selling.svg';
import ImagesHeaderSettingsSvg from '@/public/images/header/settings.svg';
import ImagesHeaderSpiritoryLogoSvg from '@/public/images/header/spiritory-logo.svg';
import ImagesHeaderSuggestABottleSvg from '@/public/images/header/suggest-a-bottle.svg';
import ImagesHeaderUserSvg from '@/public/images/header/user.svg';
import ImagesHeaderVouchersSvg from '@/public/images/header/vouchers.svg';
import ImagesHeaderWishlistSvg from '@/public/images/header/wishlist.svg';

export {
  ImagesHeaderBuyingSvg,
  ImagesHeaderChevronLeftSvg,
  ImagesHeaderChevronRightSvg,
  ImagesHeaderCloseSvg,
  ImagesHeaderDashboardSvg,
  ImagesHeaderLanguageSvg,
  ImagesHeaderLastViewedSvg,
  ImagesHeaderLogoutSvg,
  ImagesHeaderMenuSvg,
  ImagesHeaderNotificationsSvg,
  ImagesHeaderPortfolioSvg,
  ImagesHeaderSearchSvg,
  ImagesHeaderSellingSvg,
  ImagesHeaderSettingsSvg,
  ImagesHeaderSpiritoryLogoSvg,
  ImagesHeaderSuggestABottleSvg,
  ImagesHeaderUserSvg,
  ImagesHeaderVouchersSvg,
  ImagesHeaderWishlistSvg,
};
